import { constants } from 'aliases';
import Tile, { TileTemplateSpec } from 'components/common/tiles/Tile';
import TileSelectOverlay from 'components/common/tiles/TileSelectOverlay';

export type SelectableTileType = TileTemplateSpec & {
  isSelected: boolean;
  showSelectionMode: boolean;
};

export const SelectableTile = <TTemplate extends TileTemplateSpec>(
  TileClass: typeof Tile<TTemplate>,
) => {
  return class SelectableTileClass extends TileClass {
    protected _TileSelectOverlay = this.getByRef('TileSelectOverlay' as any)!;
    protected _isSelected = false;

    static override _template() {
      return {
        ...super._template(),
        TileSelectOverlay: {
          type: TileSelectOverlay,
          zIndex: constants.ui.zIndex.foregroundLayer + 3,
          visible: false,
        },
      };
    }

    override _setup() {
      super._setup();

      this._Image.on('txLoaded', () => {
        this._TileSelectOverlay.patch({
          w: this._Image.w,
          h: this._Image.h,
        });
      });
    }

    set showSelectionMode(showSelectionMode: boolean) {
      // Reset selection
      this.isSelected = false;

      this._TileSelectOverlay.patch({ visible: showSelectionMode });
      this.showDecoration(showSelectionMode);
    }

    set isSelected(isSelected: boolean) {
      this._isSelected = isSelected;
      this._TileSelectOverlay.isSelected = isSelected;
    }

    get isSelected() {
      return this._isSelected;
    }

    override onTileSelected() {
      if (this._TileSelectOverlay.visible) {
        this.isSelected = !this.isSelected;
        this.fireAncestors('$onTileEditSelected');
      } else {
        super.onTileSelected();
      }
    }
  };
};
